// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PostIntelligentCoursePartnerHomePageAdminTaskDetailQuery,
    PostIntelligentCoursePartnerHomePageAdminTaskDetailBody,
    BaseResponseIntelligentPartnerHomePageAdminCourseDetailResponse,
} from '../../../../types';

/**
 * 管理员端任务详情接口
 *
 * @export
 * @tags 智能陪练课程总览接口
 * @link [POST] /intelligentCoursePartner/homePage/admin/taskDetail
 */
export function postIntelligentCoursePartnerHomePageAdminTaskDetail(
    data: PostIntelligentCoursePartnerHomePageAdminTaskDetailBody
): Promise<BaseResponseIntelligentPartnerHomePageAdminCourseDetailResponse>;
export function postIntelligentCoursePartnerHomePageAdminTaskDetail(
    data: PostIntelligentCoursePartnerHomePageAdminTaskDetailBody,
    options: ApiOptions<never, PostIntelligentCoursePartnerHomePageAdminTaskDetailQuery>
): Promise<BaseResponseIntelligentPartnerHomePageAdminCourseDetailResponse>;
export function postIntelligentCoursePartnerHomePageAdminTaskDetail(
    data: PostIntelligentCoursePartnerHomePageAdminTaskDetailBody,
    options?: ApiOptions<never, PostIntelligentCoursePartnerHomePageAdminTaskDetailQuery>
): Promise<BaseResponseIntelligentPartnerHomePageAdminCourseDetailResponse> {
    return request<
        PostIntelligentCoursePartnerHomePageAdminTaskDetailBody,
        never,
        PostIntelligentCoursePartnerHomePageAdminTaskDetailQuery
    >('/intelligentCoursePartner/homePage/admin/taskDetail', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postIntelligentCoursePartnerHomePageAdminTaskDetail',
    });
}

export const meta = [
    {
        tags: ['智能陪练课程总览接口'],
        path: '/intelligentCoursePartner/homePage/admin/taskDetail',
        method: 'post',
    },
];
